export const APP_NAME = 'GrocieSmart';
export const APP_VERSION = '3.0';
